import { Button } from '@/components/ui'
import { getErrorMessage } from '@/api/errors'
import { AlertTriangle } from 'lucide-react'

export interface SettingsLoadErrorProps {
  error: unknown
  fallbackMessage: string
  onRetry?: () => void
  testId: string
}

export function SettingsLoadError({ error, fallbackMessage, onRetry, testId }: Readonly<SettingsLoadErrorProps>) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded border border-danger-foreground bg-danger px-3 py-2 text-sm text-danger-foreground"
      data-testid={testId}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="flex-1">
        <p>{getErrorMessage(error) ?? fallbackMessage}</p>
        {onRetry && (
          <Button variant="outline" size="sm" className="mt-2" onClick={onRetry} data-testid={`${testId}-retry`}>
            Try again
          </Button>
        )}
      </div>
    </div>
  )
}
